import { Button, Popover } from "antd"
import React, { createRef } from "react"
import PropTypes from "prop-types"
import styles from "@css/modules/Listings.module.scss"
import cssSaveSearch from "@css/modules/SaveSearchModal.module.scss"
import { observer } from "@utils/observer"
import { CloseIcon } from "@components/CloseIcon"
import { store } from "@utils/store"
import { filtersState } from "@utils/FiltersState"
import moment from "moment"
import { Email } from "@css/icons/Email"
import { SaveSearchModal } from "./SaveSearchModal"
import { withHooksToProps } from "@utils/hooks/withHooksToProps"
import { useRouter } from "next/navigation"
import { useUser, useUserSearches } from "@lib/api/user"
import { message } from "@components/Message/message"

class SaveSearch extends React.PureComponent {
    static propTypes = {
        onSaveFilters: PropTypes.func,
        where: PropTypes.object,
        router: PropTypes.object
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.where !== prevState.where) {
            return {
                ...prevState,
                where: nextProps.where
            }
        }
        return null
    }

    componentDidMount() {
        const storeValue = localStorage.getItem("saveSearchNotify")
        const canOpen = !storeValue || +storeValue < Date.now()
        if (canOpen) {
            this.unsubscribe = observer.watch("saveSearchNotify", () => {
                if (!this.state.openPopover && canOpen) {
                    this.setState({
                        openPopover: true
                    })
                }
                this.unWatchStore()
            })
            this.unWatchStore = store.watch(store.k.searches, (searches) => {
                if (searches?.length) {
                    this.closePopover()
                    this.unWatchStore()
                }
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.isModalVisible && this.state.isModalVisible) {
            const search = this.getSearch()

            if (search?.name) {
                if (this.inputRef.current) {
                    this.inputRef.current.value = search.name
                }
                this.setState({
                    withNotification: !!search.should_notify,
                    frequency: search.frequency
                })
            } else {
                this.setState({
                    withNotification: true
                })
            }
        }
    }
    componentWillUnmount() {
        if (this.unsubscribe) {
            this.unsubscribe()
            this.unWatchStore()
        }
    }

    state = {
        frequency: "2x-daily",
        withNotification: false,
        openPopover: false,
        isModalVisible: false,
        filterSaveLoading: false
    }
    inputRef = createRef()
    checkboxRef = createRef()
    closeFilterModal = () => {
        this.setState({
            isModalVisible: false
        })
    }
    openFilterModal = () => {
        const keys = Object.keys(this.state.where)
        const itemExists = keys.find((i) => i !== "status_nin" && this.state.where[i])

        if (!itemExists) {
            message.warning("Please select at least one filter criteria to save the filter")
            return
        }
        this.setState({
            isModalVisible: true
        })
    }
    getSearch = () => {
        const id = filtersState.savedSearch?.toString() || ""
        const searches = this.props.searches || []
        return searches.find((i) => i.created_at === id)
    }
    onModalOk = async () => {
        const input = this.inputRef.current
        if (!input?.value) {
            message.warning("Pleas enter filter name")
            return
        }
        this.setState({
            filterSaveLoading: true
        })
        const should_notify = this.state.withNotification ? 1 : 0
        const name = input?.value
        await this.props.onSaveFilters(
            {
                frequency: this.state.frequency,
                name,
                should_notify
            },
            this.props?.user?.username
        )
        if (input) {
            input.value = ""
        }
        this.setState({
            isModalVisible: false,
            filterSaveLoading: false
        })
    }

    onModalOkUpdate = async () => {
        const input = this.inputRef.current

        if (!input.value) {
            message.warning("Pleas enter filter name")
            return
        }
        this.setState({
            filterSaveLoading: true
        })
        const search = this.getSearch()
        const should_notify = this.state.withNotification ? 1 : 0
        const name = input.value
        await this.props.onSaveFilters(
            {
                frequency: this.state.frequency,
                name,
                should_notify,
                created_at: search.created_at
            },
            this.props?.user?.username
        )
        if (input) {
            input.value = ""
        }
        this.setState({
            isModalVisible: false,
            filterSaveLoading: false
        })
    }
    getButtons = () => {
        const search = this.getSearch()
        const backBtn = (
            <button key="back" onClick={this.closeFilterModal} className={cssSaveSearch.saveSearchBtnCancel}>
                Cancel
            </button>
        )
        const filterSaveLoading = this.state.filterSaveLoading
        if (search) {
            return [
                backBtn,
                <Button className={cssSaveSearch.saveSearchBtn} key="submit" type="primary" loading={filterSaveLoading} onClick={this.onModalOkUpdate}>
                    Update
                </Button>,
                <Button className={cssSaveSearch.saveSearchBtn} key="submitNew" loading={filterSaveLoading} onClick={this.onModalOk}>
                    Save as new
                </Button>
            ]
        } else {
            return [
                backBtn,
                <Button className={cssSaveSearch.saveSearchBtn} key="submit" type="primary" loading={filterSaveLoading} onClick={this.onModalOk}>
                    Save
                </Button>
            ]
        }
    }
    closePopover = () => {
        if (this.state.openPopover) {
            this.unsubscribe()
            this.unWatchStore()
            localStorage.setItem("saveSearchNotify", moment().add(1, "week").valueOf().toString())
            this.setState({
                openPopover: false
            })
        }
    }
    onToggleNotification = (withNotification) => {
        this.setState({
            withNotification
        })
    }
    onChangeNotificationType = (e) => {
        this.setState({
            frequency: e.target.value
        })
    }

    render() {
        const { filterSaveLoading, isModalVisible } = this.state
        return (
            <>
                <Popover
                    placement="bottomRight"
                    content={
                        <div className={styles.saveButtonPopoverContent}>
                            <button className={styles.saveButtonPopoverClose} onClick={this.closePopover}>
                                <CloseIcon />
                            </button>
                            <div>Did you know ?</div>
                            <p>You can save this alert and choose to be notified as new listings arrive</p>
                        </div>
                    }
                    open={this.state.openPopover}
                    overlayClassName={styles.saveButtonPopover}>
                    <Button className={styles.saveSearchBtn} onClick={this.openFilterModal}>
                        <Email /> Create alert
                    </Button>
                </Popover>
                {isModalVisible && (
                    <SaveSearchModal
                        inputRef={this.inputRef}
                        onToggleNotification={this.onToggleNotification}
                        getButtons={this.getButtons}
                        onChangeFrequency={this.onChangeNotificationType}
                        withNotification={this.state.withNotification}
                        frequency={this.state.frequency}
                        onClose={this.closeFilterModal}
                        loading={filterSaveLoading}
                    />
                )}
            </>
        )
    }
}

const useHooksToProps = () => {
    const { user } = useUser()
    const searches = useUserSearches()
    return {
        router: useRouter(),
        user,
        searches
    }
}

export const SaveSearchBtn = withHooksToProps(SaveSearch, useHooksToProps)
